import { BiX } from 'react-icons/bi';
import { BsCheck2 } from 'react-icons/bs';

const sharedTemplate = (args: any) => {
  let isChecked = args.isShared;
  return (
    <div>
      {isChecked ? (
        <BsCheck2 size={20} color='green' />
      ) : (
        <BiX size={20} color='red' />
      )}
    </div>
  );
};
const defaultTemplate = (args: any) => {
  let isChecked = args.isDefault;
  return (
    <div>
      {isChecked ? (
        <BsCheck2 size={20} color='green' />
      ) : (
        <BiX size={20} color='red' />
      )}
    </div>
  );
};
export const wTemplateColumns = [
  {
    field: 'name',
    headerText: 'Template Name',
    width: '25%',
    textAlign: 'Left',
  },
  {
    field: 'template_module',
    headerText: 'Template Module',
    width: '25%',
    textAlign: 'Left',
  },
  {
    field: 'template_code',
    headerText: 'Template Code',
    width: '25%',
    textAlign: 'Left',
  },
  {
    field: 'tab_name',
    headerText: 'Tab Name',
    width: '25%',
    textAlign: 'Left',
  },
  {
    field: 'isShared',
    headerText: 'Shared',
    template: sharedTemplate,
    width: '25%',
    textAlign: 'Left',
  },
  {
    field: 'isDefault',
    headerText: 'Default',
    template: defaultTemplate,
    width: '25%',
    textAlign: 'Left',
  },
];
